import React from "react";
import { Layout } from "./src/components/Layout";

/**
 * @param {JSX.Element} element
 * @param {any} props
 * @returns {JSX.Element}
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>;
}
